<div class="product-search-container" #dropdownRef>

  <div class="input-wrapper">
    <input type="text" placeholder="Agregar el producto, SKU o EAN" [(ngModel)]="searchTerm" (input)="onSearchInput()"
      (focus)="showDropdown = true" />
  </div>

  <ul *ngIf="showDropdown && products.length > 0" class="product-dropdown">
    <li *ngFor="let product of products" class="product-item">
      <img *ngIf="product.images?.length" [src]="product?.images?.[0]?.url" alt="Producto" />
      <div class="product-content">
        <span class="product-name">{{ product.name }}</span>
        <span class="sku">SKU: {{ product.sku }}</span>
        <a class="add-link" (click)="addProduct(product)">Agregar</a>
      </div>
    </li>
  </ul>


  <div *ngIf="showDropdown && products.length === 0 && hasSearched" class="no-results">
    No hay resultados
  </div>
</div>